function game_1004()
{

}
game_1004.read_odd = function(id)
{
    if(id === 1)
    {
      return "2";
    }
    else if(id === 2)
    {
      return "2";
    }
    else if(id === 3)  {
      return "3";
    }
    else if(id === 4)  {
      return "4";
    }
    else if(id === 5){
      return "5";
    }
    else if(id === 6){
      return "6";
    }
    else if(id === 7){
      return "7";
    }
    else if(id === 8){
      return "8";
    }
    else if(id === 9){
      return "9";
    }
    else if(id === 10){
      return "10";
    }
    else if(id === 11){
      return "12";
    }
    else if(id === 12){
      return "15";
    }
    else if(id === 13){
      return "18";
    }
    else if(id === 14){
      return "20";
    }
    else if(id === 15){
      return "25";
    }
    else if(id === 26)
    {
      return "2";
    }
    else if(id === 27)
    {
      return "2";
    }
    else if(id === 28)
    {
      return "4";
    }
    else if(id === 29)
    {
      return "5";
    }
    else if(id === 30)
    {
      return "6";
    }
    else if(id === 31)
    {
      return "7";
    }
    else if(id === 32)
    {
      return "8";
    }
    else if(id === 33)
    {
      return "9";
    }
    else if(id === 40)
    {
      return "18";
    }
    else if(id === 41)
    {
      return "24";
    }
    else if(id === 42)
    {
      return "30";
    }
    else if(id === 43)
    {
      return "48";
    }
    else if(id === 44)
    {
      return "60";
    }
    else if(id === 45)
    {
      return "72";
    }
    else if(id === 50){
      return  "30";
    }
    else if(id === 51){
      return  "35";
    }
    else if(id === 52){
      return  "40-100";
    }
    else if(id === 53){
      return  "300";
    }
   else if(id === 54){
     return  "100-300";
    }
    else if(id === 99){
      return  "80-200";
    }
   else if(id === 100){
      return  "10";
   }
   else if(id === 101){
      return  "10";
   }
    return  "";
}

export {
  game_1004
};



// WEBPACK FOOTER //
// ./src/components/fish/game_1004.js